import { FC } from "react";
import {
  GraphQLSchema,
  FrontendApiConfigProvider as FrontendApiConfigBaseProvider,
  useFrontendApiConfig as useFrontendApiConfigBase,
} from "@edreamsodigeo/frontend-api-client-base";

type FrontendApiConfigContext = {
  graphQLEndpoint: string;
  schema: GraphQLSchema;
};

export const useFrontendApiConfig: () => FrontendApiConfigContext =
  useFrontendApiConfigBase;

export type FrontendApiConfigProviderProps = {
  graphQLEndpoint: string;
  schema: string;
};

export const FrontendApiConfigProvider: FC<FrontendApiConfigProviderProps> =
  FrontendApiConfigBaseProvider;
